import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Wrapper from './LanguageWrapper';
import en from './languagelocalisation/en-us.json';
import fr from './languagelocalisation/fr.json';
import { BrowserRouter } from 'react-router-dom';
import { LookUpContextProvider } from './context/LookUpContextProvider';
import { initDB } from './services/storageDB';
import { CacheHandler } from './CacheHandler';
import { UnSavedChangesProvider } from './context/UnSavedChangesProvider';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

export default {
  en,
  fr,
};

// Configure PDF.js worker
// Use CDN version to ensure version compatibility and avoid maintenance overhead
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

initDB()
  .then(async () => {
    console.log('DB initialized');
    document.cookie =
      'googtrans=; path=/; domain=' +
      window.location.hostname +
      '; expires=Thu, 01 Jan 1970 00:00:00 UTC;';

    root.render(
      <div className="notranslate" translate="no">
        <UnSavedChangesProvider>
          <BrowserRouter>
            <CacheHandler>
              <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                  <Wrapper>
                    <LookUpContextProvider>
                      <App />
                    </LookUpContextProvider>
                  </Wrapper>
                </PersistGate>
              </Provider>
            </CacheHandler>
          </BrowserRouter>
        </UnSavedChangesProvider>
      </div>,
    );
  })
  .catch((error) => {
    console.log('DB initialized', error);
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
